import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {debounce, tap} from 'rxjs/operators';
import {interval} from 'rxjs';
import {ContactFormData} from '@kion/data-models';
import {SubSink} from 'subsink';

@Component({
  selector: 'kion-shop-contact-form',
  templateUrl: './shop-contact-form.component.html',
  styleUrls: ['./shop-contact-form.component.scss']
})
export class ShopContactFormComponent implements OnInit, OnDestroy {

  form: FormGroup;

  requestProperties: { key: string, value: string }[];
  @Input() subject: string;
  @Input() userEmail: string;
  @Input() userName: string;
  @Input() msg: string;
  // tslint:disable-next-line:no-output-rename
  @Output('changed') contactFormEmitter: EventEmitter<ContactFormData> = new EventEmitter<ContactFormData>();
  @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();
  private readonly subSink: SubSink;

  constructor(
    formBuilder: FormBuilder,
    private translateService: TranslateService
  ) {
    this.subSink = new SubSink();
    this.form = formBuilder.group(
      {
        request: new FormControl("", [Validators.required]),
        phone: new FormControl(null, [Validators.minLength(1), Validators.maxLength(25)]),
        name: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]),
        email: new FormControl(null, [Validators.required, Validators.email]),
        message: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(4000)]),
      }
    );
  }

  get request() {
    return this.form.get('request');
  }

  get phone() {
    return this.form.get('phone');
  }

  get name() {
    return this.form.get('name');
  }

  get email() {
    return this.form.get('email');
  }

  get message() {
    return this.form.get('message');
  }

  private static unCapitalizeFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  ngOnInit(): void {
    if (this.subject) {
      this.request.patchValue(this.subject)
    }
    if (this.userEmail) {
      this.email.patchValue(this.userEmail)
    }
    if (this.userName) {
      this.name.patchValue(this.userName);
    }
    if (this.msg) {
      this.message.patchValue(this.msg);
    }
    this.requestProperties = [
      {
        key: "PriceRequest",
        value: this.translateService.instant('forms.contact.request.' + ShopContactFormComponent.unCapitalizeFirstLetter("PriceRequest"))
      },
      {
        key: "ProductConsultation",
        value: this.translateService.instant('forms.contact.request.' + ShopContactFormComponent.unCapitalizeFirstLetter("ProductConsultation"))
      },
      {
        key: "DeliveryTimes",
        value: this.translateService.instant('forms.contact.request.' + ShopContactFormComponent.unCapitalizeFirstLetter("DeliveryTimes"))
      },
      {
        key: "Payment",
        value: this.translateService.instant('forms.contact.request.' + ShopContactFormComponent.unCapitalizeFirstLetter("Payment"))
      },
      {
        key: "Support",
        value: this.translateService.instant('forms.contact.request.' + ShopContactFormComponent.unCapitalizeFirstLetter("Support"))
      },
      {
        key: "Other",
        value: this.translateService.instant('forms.contact.request.' + ShopContactFormComponent.unCapitalizeFirstLetter("Other"))
      },
    ];
    this.subSink.sink = this.form.valueChanges
      .pipe(
        tap(() => this.valid.emit(this.form.valid)),
        debounce(() => interval(1000)))
      .subscribe(
        values => {
          if (this.form.valid) {
            const message: ContactFormData = {
              email: values.email,
              message: values.message,
              name: values.name,
              phone: values.phone,
              topic: values.request
            };
            if (this.form.touched || this.form.dirty) {
              this.contactFormEmitter.emit(message);

            }
          }
          this.valid.emit(this.form.valid);
        }
      );
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
